import { render, staticRenderFns } from "./nav.avatar.vue?vue&type=template&id=4411fef6&scoped=true&lang=pug&"
import script from "./nav.avatar.vue?vue&type=script&lang=js&"
export * from "./nav.avatar.vue?vue&type=script&lang=js&"
import style0 from "./nav.avatar.vue?vue&type=style&index=0&id=4411fef6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4411fef6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4411fef6', component.options)
    } else {
      api.reload('4411fef6', component.options)
    }
    module.hot.accept("./nav.avatar.vue?vue&type=template&id=4411fef6&scoped=true&lang=pug&", function () {
      api.rerender('4411fef6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/team_home/Activity/nav.avatar.vue"
export default component.exports